<template>
	<div class="page-contacts flex column scrollable only-y mb-20" id="page-contacts"
		v-show="userPermissionsFilter.admin" :class="[companyClass, canScroll]" v-loading="pageLoading"
		element-loading-text="Loading..." element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="page-table column mb-20" :class="{ 'flex': !isMobile, 'overflow': isMobile }">
			<h2 class="text-white">Webapp Registred Users</h2>
			<div class="table-responsive">
				<table class="table" id="datatable" style="color:white;">
					<thead>
						<tr>
							<th>Name</th>
							<th>Status</th>
							<th>User Type</th>
							<th>Email</th>
							<th>Email Verified</th>
							<th>Phone</th>
							<th>Phone Verified</th>
							<th>Platform</th>
							<th>OTP Enabled</th>
							<th>Lockout End</th>
							<th>DOB</th>
							<th>Company ID</th>
							<th>Registration Date</th>
							<th v-if="userPermissionsFilter.approveusers">View</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in usersdata" :key="item.id">
							<td v-if="item.isOrganization === false">{{ item.firstName }} {{ item.middleName }}
								{{ item.lastName }}</td>
							<td v-if="item.isOrganization === true">{{ item.organizationName }}</td>
							<td v-if="item.active === true">Active</td>
							<td v-if="item.active === false">Not Active</td>
							<td v-if="item.isOrganization === false">INDIVIDUAL</td>
							<td v-if="item.isOrganization === true">COMPANY</td>
							<td>{{ item.email }}</td>
							<td>{{ item.emailConfirmed }}</td>
							<td>{{ item.phoneNumber }}</td>
							<td>{{ item.phoneNumberConfirmed }}</td>
							<td>{{ item.platform }}</td>
							<td>{{ item.twoFactorEnabled }}</td>
							<td>{{ item.lockoutEnd }}</td>
							<td>{{ formatDate(item.dob) }}</td>
							<td>{{ item.companyID }}</td>
							<td>{{ formatShortDate(item.createdOn) }}</td>
							<td v-if="userPermissionsFilter.viewusers"><a :href="'UsersComplianceView/' + item.id"><i
										class="mdi mdi-eye"></i></a></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import $ from 'jquery';
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/';

export default {
	name: 'WebAppUsers',
	data: function () {
		return {
			usersdata: '',
			userdata: '',
			failureReasons: ["Wrong-Documents", "IPRS-Error", "Customer-Error", "System-Error"],
			failureReason: '',
			//IdProfile = "data:image/png;base64," + response.data;
		}
	},
	computed: {
		contactsClass() {
			return this.pageWidth >= 870 ? 'large' : this.pageWidth >= 760 ? 'medium' : 'small'
		},
		readOnlyMode() {
			return !this.userPermissionsFilter.addusers && !this.userPermissionsFilter.editusers;
		}
	},
	methods: {
		refreshUsers() {
			this.startLoader("Loading Users...");
			this.getWebappUsers()
				.then((result) => {
					this.usersdata = result;
					this.$nextTick(function () {
						this.initDt()
					});
					this.stopLoader();
				}).catch(err => { this.errorMessage("An Error Occured. " + err); this.stopLoader(); });
		},
		initDt() {
			$('#datatable').DataTable({
				retrieve: true,
				dom: 'Blfrtip',
				"aaSorting": [],
				initComplete: function () {
					var api = this.api();
					api.columns(4).every(function () {
					});
				},
			});
		}
	},
	mounted() {
		//API Call
	},
	created() {
		this.refreshUsers();
	},
	mixins: [PermissionsMixins]
}

</script>

<style>
table.dataTable tbody tr {
	background-color: #191d24;
}

table.dataTable {
	margin-left: 0px;
	text-align: left;
}

.avatar-box {
	background: #3773e2;
	margin-bottom: 50px;
	position: relative;
}

.avatar-box img {
	width: 100px;
	height: 100px;
	border-radius: 50%;
	position: relative;
	bottom: -50px;
	display: block;
	margin: 0 auto;
	background: white;
	border: 2px solid #3773e2;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}

.dataTables_filter label,
.dataTables_wrapper .dataTables_filter input {
	color: white !important;
}

.dataTables_wrapper .dataTables_filter input ::placeholder,
.dataTables_wrapper .dataTables_filter input ::-ms-input-placeholder {
	color: white !important;
}

.dataTables_wrapper .dataTables_paginate a.paginate_button {
	color: white !important;
}
</style>